import { useQueries } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';
import { useQueryError } from './useQueryError';

const fetchHeroImage = async () => {
  const { data, error } = await supabase
    .from("assets")
    .select("link")
    .eq("id", "dc0b4ab5-8300-4db1-8cbe-aacf42f9e788")
    .single();

  if (error) throw error;
  return data?.link;
};

const fetchButtonSvg = async () => {
  const { data, error } = await supabase
    .from("assets")
    .select("link")
    .eq("id", "86be4e58-da46-48be-b35a-e982b2f541d0")
    .single();

  if (error) throw error;
  return data?.link;
};

export function useHeroSection() {
  const { handleError } = useQueryError();

  const queries = useQueries({
    queries: [
      {
        queryKey: queryKeys.assets.byId("dc0b4ab5-8300-4db1-8cbe-aacf42f9e788"),
        queryFn: async () => {
          try {
            return await fetchHeroImage();
          } catch (error) {
            handleError(error);
            throw error;
          }
        },
        staleTime: 1000 * 60 * 60 * 24, // 24 horas - las imágenes cambian muy raramente
      },
      {
        queryKey: queryKeys.assets.byId("86be4e58-da46-48be-b35a-e982b2f541d0"),
        queryFn: async () => {
          try {
            return await fetchButtonSvg();
          } catch (error) {
            handleError(error);
            throw error;
          }
        },
        staleTime: 1000 * 60 * 60 * 24, // 24 horas
      }
    ]
  });

  const [imageQuery, buttonQuery] = queries;

  return {
    imageUrl: imageQuery.data,
    buttonSvgUrl: buttonQuery.data,
    isLoading: queries.some(query => query.isLoading),
    error: queries.find(query => query.error)?.error,
    // Estados adicionales para mejor control
    isFetching: queries.some(query => query.isFetching),
    isRefetching: queries.some(query => query.isRefetching)
  };
}